{
  "defaultTitle": "Unable to check in",
  "defaultMessage": "Please confirm the information with your dispatcher or reach out to the warehouse",
  "backToHomescreen": "Back to home screen",
  "hideErrorLog": "HIDE ERROR LOG",
  "viewErrorLog": "VIEW ERROR LOG",
  "errorLogMessageLabel": "Message:",
  "errorLogStatusLabel": "Status Code:",
  "unknown": "Unknown"
}
